(() => {

    let wrapper = document.querySelector('.video-modal')
    let modal = wrapper.querySelector('iframe')
    let triggers = document.querySelectorAll('[data-video]')

    wrapper.addEventListener('click', () => {
        modal.setAttribute('src', '')
        wrapper.classList.remove('active')
    })

    triggers.forEach( trigger => {
        let url = trigger.getAttribute('data-video')

        trigger.addEventListener('click', () => {
            modal.setAttribute('src', url)
            wrapper.classList.add('active')
        })
    })

})()